<template>
    <div>
        <v-container grid-list-md text-xs-center pa-5 fluid>
            <v-layout row align-center justify-center>
                <v-flex xs12>
                    <el-table :data="items" stripe style="width: 100%">
                        <el-table-column type="index"></el-table-column>
                        <el-table-column prop="name" label="Nama Kelompok"></el-table-column>
                        <el-table-column label="Instansi">
                            <template slot-scope="scope">{{ scope.row.instansi.name }} ({{ scope.row.instansi.provinsi.name }} - {{ scope.row.instansi.kabupaten_kota.name }})</template>
                        </el-table-column>

                        <el-table-column fixed="right" label="Operasi" width="120">
                            <template slot-scope="scope">
                                <el-button type="text" size="small" @click.stop="showPeserta(scope.row)">Beli Tiket</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </v-flex>
            </v-layout>
            <v-layout row align-center justify-center>
                <v-flex xs12>
                    <v-btn block color="accent" depressed dark @click.stop="openDialog">Buat Kelompok Baru</v-btn>
                </v-flex>
            </v-layout>
        </v-container>
        <v-dialog v-model="dialog" max-width="600px" persistent>
            <KelompokForm @close="closeDialog" :uuid="selected_uuid"></KelompokForm>
        </v-dialog>
        <ReservasiKelompok paket-enabled :selected-kelompok="selected_kelompok" v-if="show_peserta"></ReservasiKelompok>
    </div>
</template>
<script>
    import KelompokAPI from "@/api/kelompok";
    import moment from "moment";
    import store from "@/store/index";
    import {validationMixin} from 'vuelidate';
    import {required} from 'vuelidate/lib/validators';
    import KelompokForm from "@/components/kelompok/Form";
    import ReservasiKelompok from "@/components/reservasi/Kelompok";

    export default {
        components: {
            KelompokForm,
            ReservasiKelompok,
        },
        mixins: [validationMixin],
        data() {
            return {
                items: [],
                dialog: false,
                selected_uuid: null,
                show_peserta: false,
                selected_kelompok: null,
            }
        },
        computed: {

        },
        watch: {

        },
        mounted: function(){
            this.loadData();
        },
        methods: {
            showPeserta(item) {
                this.selected_kelompok = item;
                this.show_peserta = true;
            },
            openDialog(item){
                this.dialog = true;
                this.selected_uuid = null;
            },
            loadData() {
                store.dispatch("loading/start");
                KelompokAPI.loadKelompokArray().then(response => {
                    store.dispatch("loading/stop");
                    this.items = response.data.results.data;
                });
            },
            closeDialog(){
                this.dialog = false;
                this.loadData();
            },
        }
    }
</script>